import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Button, Text} from '@chakra-ui/react3'
import {ShoppingCartIcon} from '../../../../../leap/components/icons'
import {RedirectLinkPartnerModal} from '../../../../../hooks/use-redirect-link-partner-modal'

const PartnerRedirectBtn = ({redirectProps, ...props}) => {
    const {formatMessage} = useIntl()
    const {onOpen, onClick, partnerLink} = redirectProps
    const partnerLabel = formatMessage({
        id: 'partner-link.label',
        defaultMessage: 'Shop with our partner'
    })

    return (
        <>
            <RedirectLinkPartnerModal {...redirectProps} />
            <Button
                size="lg"
                variant="primaryFilled"
                bg="partner.babybunting"
                _hover={{bg: 'partner.babybunting', filter: 'brightness(0.9)'}}
                {...(partnerLink &&
                    !onOpen && {
                        as: 'a',
                        href: partnerLink,
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    })}
                aria-label={partnerLabel}
                onClick={onOpen ?? onClick}
                {...props}
            >
                <Text>{partnerLabel}</Text>
                <ShoppingCartIcon color="icons.on-color" />
            </Button>
        </>
    )
}

PartnerRedirectBtn.propTypes = {
    redirectProps: PropTypes.object
}

export default PartnerRedirectBtn
